import type { IAPI } from '../../apiResponse';
import type { IRequestOptions } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IBrowseCollectionsData } from './browse-collections-response';
import { browseCollectionsResponseSchema } from './browse-collections-response';

export async function browseCollectionsApi(options?: IRequestOptions) {
  return getRequest<IAPI<IBrowseCollectionsData>>({
    path: '/collections/v2/browse',
    schema: browseCollectionsResponseSchema,
    options,
  });
}
